"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const styled_tools_1 = require("styled-tools");
const colorTypes_1 = require("../constants/colorTypes");
const TabsBar = styled_components_1.default.div `
  position: relative;
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  padding: ${({ theme }) => theme.tabsBarPadding};
  white-space: nowrap;
  border-radius: ${({ theme }) => theme.tabsBarBorderRadius};
  border-style: solid;
  border-width: ${({ theme }) => theme.tabsBarBorderTopSize}
    ${({ theme }) => theme.tabsBarBorderRightSize} 0
    ${({ theme }) => theme.tabsBarBorderLeftSize};
  box-sizing: border-box;

  ${props => {
    const { theme } = props;
    if (theme.isClassic) {
        return (0, styled_components_1.css) `
        border-color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabsBarBorderColorDark,
            [colorTypes_1.LIGHT]: theme.tabsBarBorderColorLight,
        })};
        background: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabsBarBackgroundDark,
            [colorTypes_1.LIGHT]: theme.tabsBarBackgroundLight,
        })};

        &::after {
          background-color: ${(0, styled_tools_1.switchProp)((0, styled_tools_1.prop)('color', colorTypes_1.LIGHT), {
            [colorTypes_1.DARK]: theme.tabsBarBorderColorDark,
            [colorTypes_1.LIGHT]: theme.tabsBarBorderColorLight,
        })};
        }
      `;
    }
    return (0, styled_components_1.css) `
      border-color: ${theme.tabsBarBorderColor};
      background: ${theme.tabsBarBackground};

      &::after {
        background: ${theme.tabsBarBorderColor};
      }
    `;
}};

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${({ theme }) => theme.tabsBarBorderBottomSize};

    z-index: 1;
  }
`;
exports.default = TabsBar;
